/**
 * External dependencies
 */
import React from 'react';
import { Box, Heading, Stack } from '@towersystems/towersystems-design-system';

/**
 * Internal dependencies
 */
import ResourcesList from 'modules/dashboard/resources/resources-list';
import Main from 'components/main';

/**
 * Style dependencies
 */
import './styles.scss';

const ResourcesComponent = (props) => {
    return (
        <Main>
            <Stack space="large">
                <Heading level='1'>Resources</Heading>
                <ResourcesList />
            </Stack>
        </Main>
    );
};

export default ResourcesComponent;
